import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "mb-3"
};
const _hoisted_2 = {
  class: "m-0"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_icon = _resolveComponent("b-icon");
  const _component_b_button = _resolveComponent("b-button");
  const _component_Loading = _resolveComponent("Loading");
  const _component_b_card_header = _resolveComponent("b-card-header");
  const _component_Info = _resolveComponent("Info");
  const _component_b_card_text = _resolveComponent("b-card-text");
  const _component_b_card = _resolveComponent("b-card");
  const _component_b_alert = _resolveComponent("b-alert");
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  const _component_b_modal = _resolveComponent("b-modal");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_b_button, {
    style: {
      "transform": "translateY(4px)"
    },
    variant: $options.isCancelled ? 'success' : 'danger',
    type: "button",
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => $data.openModal = true, ["prevent"]))
  }, {
    default: _withCtx(() => [_createVNode(_component_b_icon, {
      icon: $options.actionName === 'Renew' ? 'check2-circle' : 'x-circle-fill'
    }, null, 8, ["icon"]), _createTextVNode(" " + _toDisplayString($options.actionName) + " My Subscription ", 1)], undefined, true),
    _: 1
  }, 8, ["variant"]), _createVNode(_component_b_modal, {
    id: "subscription-cancel-modal",
    modelValue: $data.openModal,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.openModal = $event),
    "no-close-on-backdrop": "",
    "no-close-on-esc": "",
    title: $options.actionName + ' My Subscription',
    "ok-title": $options.actionName + ' Subscription',
    "ok-variant": $options.isCancelled ? 'success' : 'danger',
    size: "xl",
    "cancel-title": "Close",
    onOk: $options.toggleAutoRenew
  }, {
    default: _withCtx(() => [_createVNode(_component_Loading, {
      loading: $data.loading
    }, null, 8, ["loading"]), !$data.loading ? (_openBlock(), _createBlock(_component_b_card, {
      key: 0,
      "no-body": ""
    }, {
      default: _withCtx(() => [_createVNode(_component_b_card_header, null, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createElementVNode("h3", {
          class: "m-0"
        }, "Current Subscription Info:", -1)]))], undefined, true),
        _: 1
      }), _createVNode(_component_b_card_text, {
        class: "m-3"
      }, {
        default: _withCtx(() => [_createElementVNode("h2", _hoisted_1, _toDisplayString($props.subscription.network), 1), _createVNode(_component_Info, {
          subscription: $props.subscription,
          class: "ms-3"
        }, null, 8, ["subscription"])], undefined, true),
        _: 1
      })], undefined, true),
      _: 1
    })) : _createCommentVNode("", true), !$data.loading && $props.subscription.balance <= 0 ? (_openBlock(), _createBlock(_component_b_row, {
      key: 1
    }, {
      default: _withCtx(() => [_createVNode(_component_b_col, null, {
        default: _withCtx(() => [_createVNode(_component_b_alert, {
          variant: "info",
          class: "text-center m-3",
          show: ""
        }, {
          default: _withCtx(() => [_createElementVNode("h3", _hoisted_2, " Your subscription will " + _toDisplayString($options.actionName === "Renew" ? " resume billing on " : " remain active until ") + " " + _toDisplayString($props.subscription.enddate) + ". ", 1)], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      })], undefined, true),
      _: 1
    })) : _createCommentVNode("", true)], undefined, true),
    _: 1
  }, 8, ["modelValue", "title", "ok-title", "ok-variant", "onOk"])]);
}